module.exports = {
          srcSet: __webpack_public_path__ + "4899ed7aed025eaae2ae5194454f03fa-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "4899ed7aed025eaae2ae5194454f03fa-60.png",width: 60,height: 60}],
          src: __webpack_public_path__ + "4899ed7aed025eaae2ae5194454f03fa-60.png",
          toString:function(){return __webpack_public_path__ + "4899ed7aed025eaae2ae5194454f03fa-60.png"},
          
          width: 60,
          height: 60
        }